module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAIUlEQVQ4y2NgGBRgsYHFf3LwqAFIBvwnE1DPgNFYGOoAAEW6cIyh7xS5AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/LV.png
// module id = 1198
// module chunks = 0